import { Application } from "@hotwired/stimulus"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"
import "shared"
import "helpers"
import "dialog-polyfill/dist/dialog-polyfill.css"
import { initGlobalState } from "shared/init_global_state"

const application = Application.start()
const sharedContext = require.context("controllers/shared", true, /_controller\.js$/)
const businessContext = require.context("controllers/business", true, /_controller\.js$/)

application.load(definitionsFromContext(sharedContext))
application.load(definitionsFromContext(businessContext))

global.application = application
global.state = initGlobalState()
